import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { StyledButton } from "../../../components/Button/button";
import { useAppDispatch } from "../../../hooks/redux-hooks";
import { auth } from "../../../redux/actions";
import SessionService from "../../../services/session-service";
import { getAllUsers } from "../../../services/users/get-all";
import { getLoggedUsersData } from "../../../services/users/get-logged";

const OperatorLoggedDashboard = () => {
  const dispatch = useAppDispatch();
  let navigate = useNavigate();
  const { isLoading } = useQuery(["loggedUsersData"], getLoggedUsersData, {
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    onSuccess(data) {
      SessionService.setLoggedUserData(data.data.payload.dane_operator);
    },
  });
  const handleSubmitLogout = () => {
    SessionService.clearUserSession();
    SessionService.clearLoggedUserData();
    dispatch(auth.userLogout());
    navigate("/login");
  };

  return (
    <></>
    // <PageContainer>
    //   <h1>Panel Operatora</h1>
    //   <StyledButton style={{ width: "320px" }} onClick={handleSubmitLogout}>
    //     Wyloguj się
    //   </StyledButton>
    // </PageContainer>
  );
};
const PageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 40px 0px;
  width: 100%;
  height: 100%;
`;
export default OperatorLoggedDashboard;
